// Bridge: re-export the project form implementation from `src/projects/pages`
import ProjectFormPage from "../projects/pages/ProjectFormPage";

export default ProjectFormPage;
